import { ChangeDetectionStrategy, Component } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { FeatureFlagService } from '@examdojo/core/feature-flag';
import { FullscreenMessageComponent } from '@examdojo/core/fullscreen-message';
import { ExamDojoFeatureFlag, ExamdojoFeatureFlags } from '@examdojo/models/feature-flag';
import { TranslocoPipe } from '@jsverse/transloco';
import { map } from 'rxjs';

@Component({
  selector: 'dojo-maintenance-page',
  template: `
    <y42-fullscreen-message
      [header]="'examdojo.maintenance_page.header' | transloco"
      [description]="'examdojo.maintenance_page.description' | transloco: { estimatedTime: state.estimatedTime }"
      [maxWidth]="'500px'"
    >
      <footer></footer>
    </y42-fullscreen-message>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col h-full justify-center' },
  imports: [FullscreenMessageComponent, TranslocoPipe],
})
export class MaintenancePageComponent {
  constructor(private readonly featureFlagService: FeatureFlagService<ExamdojoFeatureFlags>) {}

  private readonly defaultEstimatedTime = 'about 30 mins (possibly up to an hour in some cases)';

  private readonly estimatedTime$ = this.featureFlagService.select(ExamDojoFeatureFlag.Maintenance).pipe(
    map((flagValue) => {
      if (typeof flagValue === 'string') {
        return flagValue;
      }
      return this.defaultEstimatedTime;
    }),
  );

  readonly state = connectState({
    estimatedTime: this.estimatedTime$,
  });
}
